export const scrollIntoView = (id) => {
    const element = document.getElementById(id)
    const main = document.getElementById('main')
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
        main.scrollTo({ top: 0 })
    }
}
